/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FileUploadFolder {
    RECIPE_INPUTS = 'recipe-inputs',
    RECIPE_THUMBNAILS = 'recipe-thumbnails',
}
